export default __webpack_public_path__ + "static/media/beegees.432e752f.jpg";